module.exports = __webpack_public_path__ + "static/img/1.8857f04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/1.jpg
// module id = U9Cs
// module chunks = 1